module.exports = __webpack_public_path__ + "img/neo4j.ddd0657a.svg";